import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteBreadcrumbs from "./SiteBreadcrumbs";

/**
 * Shared top row: optional back link (left) + breadcrumb trail (right).
 */
export default function PageTopbar({
  backTo,
  backLabel,
  backState,
  onBackClick,
  breadcrumbItems,
  breadcrumbsOnly = false,
  className = "",
}) {
  const hasBack = backTo != null && String(backLabel || "").trim() !== "";
  const hasBreadcrumbs = Array.isArray(breadcrumbItems) && breadcrumbItems.length > 0;

  if (!hasBack && !hasBreadcrumbs) return null;

  const topbarClass = [
    "jw-page-topbar",
    breadcrumbsOnly ? "jw-page-topbar--breadcrumbs-only" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={topbarClass}>
      {hasBack ? (
        <Link
          className="jw-page-topbar__back nd1-auth-back"
          to={backTo}
          state={backState}
          onClick={onBackClick}
        >
          <ArrowLeft className="nd1-icon" aria-hidden="true" />
          {backLabel}
        </Link>
      ) : null}
      {hasBreadcrumbs ? <SiteBreadcrumbs items={breadcrumbItems} /> : null}
    </div>
  );
}
